module.exports = __webpack_public_path__ + "media/images/icon/payment/visa-blue-4a815f501d17776d2bc49851a8c5a481.svg";